import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase, AngularFireObject } from '@angular/fire/database';
import * as firebase from 'firebase/app';
import { concatMap, map } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { Observable, EMPTY, zip } from 'rxjs';
import {FlashMessagesService} from 'angular2-flash-messages';
import { Router} from '@angular/router';
import { User } from '../interfaces/user';



@Injectable({providedIn: 'root'})
export class AuthService {
  public isSignedInStream: Observable<boolean>;
  public user: Observable<User|null> = EMPTY;

  constructor(private afAuth: AngularFireAuth, private db: AngularFireDatabase,) {
    this.isSignedInStream = this.afAuth.authState
    .pipe(map<firebase.default.User | null, boolean>((user: (firebase.default.User | null)) => {
       return user != null;
    }));
    this.user = this.afAuth.authState
    .pipe(map((user: (firebase.default.User | null)) => user?.uid ?? "_"),
    concatMap(id => this.getUser(id).valueChanges()))
   
  }


  private getUser(id:string):AngularFireObject<User>{
    return this.db.object(this.db.database.ref("users")
    .child(id));
  }

  loginEmail(email: string, pass: string) {
    return new Promise((resolve, reject) => {
    this.afAuth.signInWithEmailAndPassword(email, pass)
    .then(res => {
      return resolve(res);
    })
     .catch(err => {
      return reject (err);
      });
    })
  }

  logout() {
    return this.afAuth.signOut();
}
}


